import { render, staticRenderFns } from "./ClientsSideview.vue?vue&type=template&id=ea83fc56&scoped=true&class=fill-height"
import script from "./ClientsSideview.vue?vue&type=script&lang=ts"
export * from "./ClientsSideview.vue?vue&type=script&lang=ts"
import style0 from "./ClientsSideview.vue?vue&type=style&index=0&id=ea83fc56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea83fc56",
  null
  
)

export default component.exports